import { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import BrandSection from '../Section/BrandSection';
import ServiceSectionStyle4 from '../Section/ServiceSection/ServiceSectionStyle4';
import TestimonialSection from '../Section/TestimonialSection';
import { PAGE_SEO } from '../../config/seo';
import { useSEO } from '../../helpers/useSEO';import ServiceSectionStyle2 from '../Section/ServiceSection/ServiceSectionStyle2';

const serviceData = [
  {
    iconUrl: '/images/icons/service_icon_1.svg',
    title: 'Études structurelles',
    subTitle:
      'Conception et dimensionnement des structures béton armé, métalliques et mixtes pour tous types de bâtiments.',
    imgUrl: '/images/service1.svg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_2.svg',
    title: 'Suivi et pilotage de chantier',
    subTitle:
      'Notre équipe assure un suivi personnalisé sur site, incluant la supervision des travaux, l\'assistance technique et le contrôle rigoureux de l\'exécution.',
    imgUrl: '/images/project_1.jpeg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_3.svg',
    title: "Études d'exécution",
    subTitle:
      'Nous réalisons les plans d\'exécution, la synthèse technique et la coordination de votre chantier.',
    imgUrl: '/images/service3.svg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_4.svg',
    title: 'Optimisation des coûts de construction',
    subTitle:
      'Recherche de solutions techniques permettant de réduire les coûts sans compromettre la qualité.',
    imgUrl: '/images/service4.svg',
    href: '/service/services-details',
  },
];

const testimonialData = [
  {
    imgUrl: '/images/avatar_1.png',
    rating: '5',
    desc: 'Une équipe très professionnelle et réactive. Les études techniques étaient précises et parfaitement adaptées à notre projet. Le suivi a été sérieux du début à la fin.',
    name: 'Nour Ben Youssef',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_2.png',
    rating: '5',
    desc: 'Excellent bureau d\'études. Les solutions proposées ont permis d\'optimiser les coûts tout en respectant les normes de construction. Une vraie valeur ajoutée.',
    name: 'Amine Trabelsi',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_3.png',
    rating: '5',
    desc: 'Un accompagnement rigoureux et un suivi de chantier impeccable. L\'équipe maîtrise parfaitement les aspects techniques et organisationnels.',
    name: 'Leila Bouzid',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_4.png',
    rating: '5',
    desc: 'Nexting Études a su comprendre nos besoins et proposer des solutions fiables. Nous recommandons leurs services sans hésitation.',
    name: 'Sami Jaziri',
    designation: 'Client',
  },
];
const brandData = [
  { imgUrl: '/images/brand_1.svg' },
  { imgUrl: '/images/brand_2.svg' },
  { imgUrl: '/images/brand_3.svg' },
  { imgUrl: '/images/brand_4.svg' },
  { imgUrl: '/images/brand_5.svg' },
];



export default function ServicesPage() {
  useSEO(PAGE_SEO.services);
  useEffect(() => {    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="Services" bgUrl="/images/about.jpg" />

      <Section pt="140" ptLg="80" pb="115" pbLg="55">
        <ServiceSectionStyle2
          sectionTitleUp=" Nos Services "
          sectionTitle="Une expertise au service de vos ambitions"
          data={serviceData}
          compact
        />
      </Section>



      <Section
        pt="140"
        ptLg="75"
        pb="135"
        pbLg="75"
        className="cs_section_with_shape position-relative overflow-hidden"
        style={{ backgroundImage: `url(${'/images/testimonial_bg.jpeg'})` }}
      >
        <TestimonialSection
          sectionTitleUp="Témoignages clients
"
          sectionTitle="Que disent-ils ?"
          sectionSubTitle="Les retours de nos clients reflètent notre engagement à fournir des études techniques fiables, précises et adaptées à chaque projet."
          data={testimonialData}
        />
      </Section>
    </>
  );
}
